import { jsx as M, jsxs as K, Fragment as We } from "react/jsx-runtime";
import * as g from "react";
import Z, { useMemo as Ce } from "react";
import { s as w } from "../../chunks/style.module.js";
import { P as t, b as oe, g as pe, a as me, s as G, u as he, d as ye, r as Ve } from "../../chunks/DefaultPropsProvider.js";
import { r as Je, m as Be, a as Ge, u as Xe, g as Qe, o as ce, b as le, c as Ze, e as et, M as tt, P as nt, d as ne, f as ot, H as ue, i as rt } from "../../chunks/Paper.js";
import { u as st } from "../../chunks/useTheme.js";
import { u as ge, a as it, T as at, r as ct, g as Pe, c as lt, e as ut } from "../../chunks/utils.js";
function ft(n, o = 166) {
  let r;
  function f(...u) {
    const s = () => {
      n.apply(this, u);
    };
    clearTimeout(r), r = setTimeout(s, o);
  }
  return f.clear = () => {
    clearTimeout(r);
  }, f;
}
function dt(n) {
  var v;
  const {
    elementType: o,
    externalSlotProps: r,
    ownerState: f,
    skipResolvingSlotProps: u = !1,
    ...s
  } = n, i = u ? {} : Je(r, f), {
    props: l,
    internalRef: d
  } = Be({
    ...s,
    externalSlotProps: i
  }), E = ge(d, i == null ? void 0 : i.ref, (v = n.additionalProps) == null ? void 0 : v.ref);
  return Ge(o, {
    ...l,
    ref: E
  }, f);
}
const pt = /* @__PURE__ */ g.createContext();
process.env.NODE_ENV !== "production" && (t.node, t.bool);
const mt = () => g.useContext(pt) ?? !1;
function ht(n, o) {
  if (!n)
    return o;
  if (typeof n == "function" || typeof o == "function")
    return (u) => {
      const s = typeof o == "function" ? o(u) : o, i = typeof n == "function" ? n({
        ...u,
        ...s
      }) : n, l = oe(u == null ? void 0 : u.className, s == null ? void 0 : s.className, i == null ? void 0 : i.className);
      return {
        ...s,
        ...i,
        ...!!l && {
          className: l
        },
        ...(s == null ? void 0 : s.style) && (i == null ? void 0 : i.style) && {
          style: {
            ...s.style,
            ...i.style
          }
        },
        ...(s == null ? void 0 : s.sx) && (i == null ? void 0 : i.sx) && {
          sx: [...Array.isArray(s.sx) ? s.sx : [s.sx], ...Array.isArray(i.sx) ? i.sx : [i.sx]]
        }
      };
    };
  const r = o, f = oe(r == null ? void 0 : r.className, n == null ? void 0 : n.className);
  return {
    ...o,
    ...n,
    ...!!f && {
      className: f
    },
    ...(r == null ? void 0 : r.style) && (n == null ? void 0 : n.style) && {
      style: {
        ...r.style,
        ...n.style
      }
    },
    ...(r == null ? void 0 : r.sx) && (n == null ? void 0 : n.sx) && {
      sx: [...Array.isArray(r.sx) ? r.sx : [r.sx], ...Array.isArray(n.sx) ? n.sx : [n.sx]]
    }
  };
}
var fe = { exports: {} }, R = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oe;
function yt() {
  if (Oe)
    return R;
  Oe = 1;
  var n = Symbol.for("react.transitional.element"), o = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), f = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), s = Symbol.for("react.consumer"), i = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), P = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), S = Symbol.for("react.view_transition"), h = Symbol.for("react.client.reference");
  function p(e) {
    if (typeof e == "object" && e !== null) {
      var a = e.$$typeof;
      switch (a) {
        case n:
          switch (e = e.type, e) {
            case r:
            case u:
            case f:
            case d:
            case E:
            case S:
              return e;
            default:
              switch (e = e && e.$$typeof, e) {
                case i:
                case l:
                case v:
                case P:
                  return e;
                case s:
                  return e;
                default:
                  return a;
              }
          }
        case o:
          return a;
      }
    }
  }
  return R.ContextConsumer = s, R.ContextProvider = i, R.Element = n, R.ForwardRef = l, R.Fragment = r, R.Lazy = v, R.Memo = P, R.Portal = o, R.Profiler = u, R.StrictMode = f, R.Suspense = d, R.SuspenseList = E, R.isContextConsumer = function(e) {
    return p(e) === s;
  }, R.isContextProvider = function(e) {
    return p(e) === i;
  }, R.isElement = function(e) {
    return typeof e == "object" && e !== null && e.$$typeof === n;
  }, R.isForwardRef = function(e) {
    return p(e) === l;
  }, R.isFragment = function(e) {
    return p(e) === r;
  }, R.isLazy = function(e) {
    return p(e) === v;
  }, R.isMemo = function(e) {
    return p(e) === P;
  }, R.isPortal = function(e) {
    return p(e) === o;
  }, R.isProfiler = function(e) {
    return p(e) === u;
  }, R.isStrictMode = function(e) {
    return p(e) === f;
  }, R.isSuspense = function(e) {
    return p(e) === d;
  }, R.isSuspenseList = function(e) {
    return p(e) === E;
  }, R.isValidElementType = function(e) {
    return typeof e == "string" || typeof e == "function" || e === r || e === u || e === f || e === d || e === E || typeof e == "object" && e !== null && (e.$$typeof === v || e.$$typeof === P || e.$$typeof === i || e.$$typeof === s || e.$$typeof === l || e.$$typeof === h || e.getModuleId !== void 0);
  }, R.typeOf = p, R;
}
var C = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ne;
function gt() {
  return Ne || (Ne = 1, process.env.NODE_ENV !== "production" && function() {
    function n(e) {
      if (typeof e == "object" && e !== null) {
        var a = e.$$typeof;
        switch (a) {
          case o:
            switch (e = e.type, e) {
              case f:
              case s:
              case u:
              case E:
              case P:
              case h:
                return e;
              default:
                switch (e = e && e.$$typeof, e) {
                  case l:
                  case d:
                  case S:
                  case v:
                    return e;
                  case i:
                    return e;
                  default:
                    return a;
                }
            }
          case r:
            return a;
        }
      }
    }
    var o = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), f = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), P = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), h = Symbol.for("react.view_transition"), p = Symbol.for("react.client.reference");
    C.ContextConsumer = i, C.ContextProvider = l, C.Element = o, C.ForwardRef = d, C.Fragment = f, C.Lazy = S, C.Memo = v, C.Portal = r, C.Profiler = s, C.StrictMode = u, C.Suspense = E, C.SuspenseList = P, C.isContextConsumer = function(e) {
      return n(e) === i;
    }, C.isContextProvider = function(e) {
      return n(e) === l;
    }, C.isElement = function(e) {
      return typeof e == "object" && e !== null && e.$$typeof === o;
    }, C.isForwardRef = function(e) {
      return n(e) === d;
    }, C.isFragment = function(e) {
      return n(e) === f;
    }, C.isLazy = function(e) {
      return n(e) === S;
    }, C.isMemo = function(e) {
      return n(e) === v;
    }, C.isPortal = function(e) {
      return n(e) === r;
    }, C.isProfiler = function(e) {
      return n(e) === s;
    }, C.isStrictMode = function(e) {
      return n(e) === u;
    }, C.isSuspense = function(e) {
      return n(e) === E;
    }, C.isSuspenseList = function(e) {
      return n(e) === P;
    }, C.isValidElementType = function(e) {
      return typeof e == "string" || typeof e == "function" || e === f || e === s || e === u || e === E || e === P || typeof e == "object" && e !== null && (e.$$typeof === S || e.$$typeof === v || e.$$typeof === l || e.$$typeof === i || e.$$typeof === d || e.$$typeof === p || e.getModuleId !== void 0);
    }, C.typeOf = n;
  }()), C;
}
process.env.NODE_ENV === "production" ? fe.exports = yt() : fe.exports = gt();
var xe = fe.exports;
const Ae = /* @__PURE__ */ g.createContext({});
process.env.NODE_ENV !== "production" && (Ae.displayName = "ListContext");
const Et = Ae;
function Tt(n) {
  return pe("MuiList", n);
}
me("MuiList", ["root", "padding", "dense", "subheader"]);
const vt = (n) => {
  const {
    classes: o,
    disablePadding: r,
    dense: f,
    subheader: u
  } = n;
  return ye({
    root: ["root", !r && "padding", f && "dense", u && "subheader"]
  }, Tt, o);
}, bt = G("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (n, o) => {
    const {
      ownerState: r
    } = n;
    return [o.root, !r.disablePadding && o.padding, r.dense && o.dense, r.subheader && o.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: n
    }) => !n.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: n
    }) => n.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), Le = /* @__PURE__ */ g.forwardRef(function(o, r) {
  const f = he({
    props: o,
    name: "MuiList"
  }), {
    children: u,
    className: s,
    component: i = "ul",
    dense: l = !1,
    disablePadding: d = !1,
    subheader: E,
    ...P
  } = f, v = g.useMemo(() => ({
    dense: l
  }), [l]), S = {
    ...f,
    component: i,
    dense: l,
    disablePadding: d
  }, h = vt(S);
  return /* @__PURE__ */ M(Et.Provider, {
    value: v,
    children: /* @__PURE__ */ K(bt, {
      as: i,
      className: oe(h.root, s),
      ref: r,
      ownerState: S,
      ...P,
      children: [E, u]
    })
  });
});
process.env.NODE_ENV !== "production" && (Le.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: t.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: t.object,
  /**
   * @ignore
   */
  className: t.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: t.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: t.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: t.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: t.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: t.oneOfType([t.arrayOf(t.oneOfType([t.func, t.object, t.bool])), t.func, t.object])
});
const Rt = Le;
function ie(n, o, r) {
  return n === o ? n.firstChild : o && o.nextElementSibling ? o.nextElementSibling : r ? null : n.firstChild;
}
function _e(n, o, r) {
  return n === o ? r ? n.firstChild : n.lastChild : o && o.previousElementSibling ? o.previousElementSibling : r ? null : n.lastChild;
}
function Ie(n, o) {
  if (o === void 0)
    return !0;
  let r = n.innerText;
  return r === void 0 && (r = n.textContent), r = r.trim().toLowerCase(), r.length === 0 ? !1 : o.repeating ? r[0] === o.keys[0] : r.startsWith(o.keys.join(""));
}
function ee(n, o, r, f, u, s) {
  let i = !1, l = u(n, o, o ? r : !1);
  for (; l; ) {
    if (l === n.firstChild) {
      if (i)
        return !1;
      i = !0;
    }
    const d = f ? !1 : l.disabled || l.getAttribute("aria-disabled") === "true";
    if (!l.hasAttribute("tabindex") || !Ie(l, s) || d)
      l = u(n, l, r);
    else
      return l.focus(), !0;
  }
  return !1;
}
const $e = /* @__PURE__ */ g.forwardRef(function(o, r) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: f,
    autoFocus: u = !1,
    autoFocusItem: s = !1,
    children: i,
    className: l,
    disabledItemsFocusable: d = !1,
    disableListWrap: E = !1,
    onKeyDown: P,
    variant: v = "selectedMenu",
    ...S
  } = o, h = g.useRef(null), p = g.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Xe(() => {
    u && h.current.focus();
  }, [u]), g.useImperativeHandle(f, () => ({
    adjustStyleForScrollbar: (m, {
      direction: T
    }) => {
      const b = !h.current.style.width;
      if (m.clientHeight < h.current.clientHeight && b) {
        const D = `${Qe(ce(m))}px`;
        h.current.style[T === "rtl" ? "paddingLeft" : "paddingRight"] = D, h.current.style.width = `calc(100% + ${D})`;
      }
      return h.current;
    }
  }), []);
  const e = (m) => {
    const T = h.current, b = m.key;
    if (m.ctrlKey || m.metaKey || m.altKey) {
      P && P(m);
      return;
    }
    const k = le(T).activeElement;
    if (b === "ArrowDown")
      m.preventDefault(), ee(T, k, E, d, ie);
    else if (b === "ArrowUp")
      m.preventDefault(), ee(T, k, E, d, _e);
    else if (b === "Home")
      m.preventDefault(), ee(T, null, E, d, ie);
    else if (b === "End")
      m.preventDefault(), ee(T, null, E, d, _e);
    else if (b.length === 1) {
      const N = p.current, z = b.toLowerCase(), W = performance.now();
      N.keys.length > 0 && (W - N.lastTime > 500 ? (N.keys = [], N.repeating = !0, N.previousKeyMatched = !0) : N.repeating && z !== N.keys[0] && (N.repeating = !1)), N.lastTime = W, N.keys.push(z);
      const q = k && !N.repeating && Ie(k, N);
      N.previousKeyMatched && (q || ee(T, k, !1, d, ie, N)) ? m.preventDefault() : N.previousKeyMatched = !1;
    }
    P && P(m);
  }, a = ge(h, r);
  let c = -1;
  g.Children.forEach(i, (m, T) => {
    if (!/* @__PURE__ */ g.isValidElement(m)) {
      c === T && (c += 1, c >= i.length && (c = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && xe.isFragment(m) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), m.props.disabled || (v === "selectedMenu" && m.props.selected || c === -1) && (c = T), c === T && (m.props.disabled || m.props.muiSkipListHighlight || m.type.muiSkipListHighlight) && (c += 1, c >= i.length && (c = -1));
  });
  const A = g.Children.map(i, (m, T) => {
    if (T === c) {
      const b = {};
      return s && (b.autoFocus = !0), m.props.tabIndex === void 0 && v === "selectedMenu" && (b.tabIndex = 0), /* @__PURE__ */ g.cloneElement(m, b);
    }
    return m;
  });
  return /* @__PURE__ */ M(Rt, {
    role: "menu",
    ref: a,
    className: l,
    onKeyDown: e,
    tabIndex: u ? 0 : -1,
    ...S,
    children: A
  });
});
process.env.NODE_ENV !== "production" && ($e.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: t.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: t.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: t.node,
  /**
   * @ignore
   */
  className: t.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: t.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: t.bool,
  /**
   * @ignore
   */
  onKeyDown: t.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: t.oneOf(["menu", "selectedMenu"])
});
const Ct = $e;
function Pt(n) {
  return typeof n == "string";
}
function de(n) {
  return `scale(${n}, ${n ** 2})`;
}
const Ot = {
  entering: {
    opacity: 1,
    transform: de(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, ae = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), se = /* @__PURE__ */ g.forwardRef(function(o, r) {
  const {
    addEndListener: f,
    appear: u = !0,
    children: s,
    easing: i,
    in: l,
    onEnter: d,
    onEntered: E,
    onEntering: P,
    onExit: v,
    onExited: S,
    onExiting: h,
    style: p,
    timeout: e = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: a = at,
    ...c
  } = o, A = it(), m = g.useRef(), T = st(), b = g.useRef(null), D = ge(b, Ze(s), r), k = (_) => (I) => {
    if (_) {
      const F = b.current;
      I === void 0 ? _(F) : _(F, I);
    }
  }, N = k(P), z = k((_, I) => {
    ct(_);
    const {
      duration: F,
      delay: Y,
      easing: y
    } = Pe({
      style: p,
      timeout: e,
      easing: i
    }, {
      mode: "enter"
    });
    let L;
    e === "auto" ? (L = T.transitions.getAutoHeightDuration(_.clientHeight), m.current = L) : L = F, _.style.transition = [T.transitions.create("opacity", {
      duration: L,
      delay: Y
    }), T.transitions.create("transform", {
      duration: ae ? L : L * 0.666,
      delay: Y,
      easing: y
    })].join(","), d && d(_, I);
  }), W = k(E), q = k(h), U = k((_) => {
    const {
      duration: I,
      delay: F,
      easing: Y
    } = Pe({
      style: p,
      timeout: e,
      easing: i
    }, {
      mode: "exit"
    });
    let y;
    e === "auto" ? (y = T.transitions.getAutoHeightDuration(_.clientHeight), m.current = y) : y = I, _.style.transition = [T.transitions.create("opacity", {
      duration: y,
      delay: F
    }), T.transitions.create("transform", {
      duration: ae ? y : y * 0.666,
      delay: ae ? F : F || y * 0.333,
      easing: Y
    })].join(","), _.style.opacity = 0, _.style.transform = de(0.75), v && v(_);
  }), V = k(S);
  return /* @__PURE__ */ M(a, {
    appear: u,
    in: l,
    nodeRef: b,
    onEnter: z,
    onEntered: W,
    onEntering: N,
    onExit: U,
    onExited: V,
    onExiting: q,
    addEndListener: (_) => {
      e === "auto" && A.start(m.current || 0, _), f && f(b.current, _);
    },
    timeout: e === "auto" ? null : e,
    ...c,
    children: (_, {
      ownerState: I,
      ...F
    }) => /* @__PURE__ */ g.cloneElement(s, {
      style: {
        opacity: 0,
        transform: de(0.75),
        visibility: _ === "exited" && !l ? "hidden" : void 0,
        ...Ot[_],
        ...p,
        ...s.props.style
      },
      ref: D,
      ...F
    })
  });
});
process.env.NODE_ENV !== "production" && (se.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: t.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: t.bool,
  /**
   * A single child content element.
   */
  children: et.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: t.oneOfType([t.shape({
    enter: t.string,
    exit: t.string
  }), t.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: t.bool,
  /**
   * @ignore
   */
  onEnter: t.func,
  /**
   * @ignore
   */
  onEntered: t.func,
  /**
   * @ignore
   */
  onEntering: t.func,
  /**
   * @ignore
   */
  onExit: t.func,
  /**
   * @ignore
   */
  onExited: t.func,
  /**
   * @ignore
   */
  onExiting: t.func,
  /**
   * @ignore
   */
  style: t.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: t.oneOfType([t.oneOf(["auto"]), t.number, t.shape({
    appear: t.number,
    enter: t.number,
    exit: t.number
  })])
});
se && (se.muiSupportAuto = !0);
const Nt = se;
function _t(n) {
  return pe("MuiPopover", n);
}
me("MuiPopover", ["root", "paper"]);
function Me(n, o) {
  let r = 0;
  return typeof o == "number" ? r = o : o === "center" ? r = n.height / 2 : o === "bottom" && (r = n.height), r;
}
function we(n, o) {
  let r = 0;
  return typeof o == "number" ? r = o : o === "center" ? r = n.width / 2 : o === "right" && (r = n.width), r;
}
function Se(n) {
  return [n.horizontal, n.vertical].map((o) => typeof o == "number" ? `${o}px` : o).join(" ");
}
function te(n) {
  return typeof n == "function" ? n() : n;
}
const Mt = (n) => {
  const {
    classes: o
  } = n;
  return ye({
    root: ["root"],
    paper: ["paper"]
  }, _t, o);
}, wt = G(tt, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (n, o) => o.root
})({}), ke = G(nt, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (n, o) => o.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Fe = /* @__PURE__ */ g.forwardRef(function(o, r) {
  const f = he({
    props: o,
    name: "MuiPopover"
  }), {
    action: u,
    anchorEl: s,
    anchorOrigin: i = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: l,
    anchorReference: d = "anchorEl",
    children: E,
    className: P,
    container: v,
    elevation: S = 8,
    marginThreshold: h = 16,
    open: p,
    PaperProps: e = {},
    // TODO: remove in v7
    slots: a = {},
    slotProps: c = {},
    transformOrigin: A = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: m,
    // TODO: remove in v7
    transitionDuration: T = "auto",
    TransitionProps: b = {},
    // TODO: remove in v7
    disableScrollLock: D = !1,
    ...k
  } = f, N = g.useRef(), z = {
    ...f,
    anchorOrigin: i,
    anchorReference: d,
    elevation: S,
    marginThreshold: h,
    transformOrigin: A,
    TransitionComponent: m,
    transitionDuration: T,
    TransitionProps: b
  }, W = Mt(z), q = g.useCallback(() => {
    if (d === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (l || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), l;
    const O = te(s), x = O && O.nodeType === 1 ? O : le(N.current).body, $ = x.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const H = x.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && H.top === 0 && H.left === 0 && H.right === 0 && H.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: $.top + Me($, i.vertical),
      left: $.left + we($, i.horizontal)
    };
  }, [s, i.horizontal, i.vertical, l, d]), U = g.useCallback((O) => ({
    vertical: Me(O, A.vertical),
    horizontal: we(O, A.horizontal)
  }), [A.horizontal, A.vertical]), V = g.useCallback((O) => {
    const x = {
      width: O.offsetWidth,
      height: O.offsetHeight
    }, $ = U(x);
    if (d === "none")
      return {
        top: null,
        left: null,
        transformOrigin: Se($)
      };
    const H = q();
    let J = H.top - $.vertical, B = H.left - $.horizontal;
    const Te = J + x.height, ve = B + x.width, be = ce(te(s)), Q = be.innerHeight - h, Re = be.innerWidth - h;
    if (h !== null && J < h) {
      const j = J - h;
      J -= j, $.vertical += j;
    } else if (h !== null && Te > Q) {
      const j = Te - Q;
      J -= j, $.vertical += j;
    }
    if (process.env.NODE_ENV !== "production" && x.height > Q && x.height && Q && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${x.height - Q}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), h !== null && B < h) {
      const j = B - h;
      B -= j, $.horizontal += j;
    } else if (ve > Re) {
      const j = ve - Re;
      B -= j, $.horizontal += j;
    }
    return {
      top: `${Math.round(J)}px`,
      left: `${Math.round(B)}px`,
      transformOrigin: Se($)
    };
  }, [s, d, q, U, h]), [re, _] = g.useState(p), I = g.useCallback(() => {
    const O = N.current;
    if (!O)
      return;
    const x = V(O);
    x.top !== null && O.style.setProperty("top", x.top), x.left !== null && (O.style.left = x.left), O.style.transformOrigin = x.transformOrigin, _(!0);
  }, [V]);
  g.useEffect(() => (D && window.addEventListener("scroll", I), () => window.removeEventListener("scroll", I)), [s, D, I]);
  const F = () => {
    I();
  }, Y = () => {
    _(!1);
  };
  g.useEffect(() => {
    p && I();
  }), g.useImperativeHandle(u, () => p ? {
    updatePosition: () => {
      I();
    }
  } : null, [p, I]), g.useEffect(() => {
    if (!p)
      return;
    const O = ft(() => {
      I();
    }), x = ce(te(s));
    return x.addEventListener("resize", O), () => {
      O.clear(), x.removeEventListener("resize", O);
    };
  }, [s, p, I]);
  let y = T;
  const L = {
    slots: {
      transition: m,
      ...a
    },
    slotProps: {
      transition: b,
      paper: e,
      ...c
    }
  }, [X, Ye] = ne("transition", {
    elementType: Nt,
    externalForwardedProps: L,
    ownerState: z,
    getSlotProps: (O) => ({
      ...O,
      onEntering: (x, $) => {
        var H;
        (H = O.onEntering) == null || H.call(O, x, $), F();
      },
      onExited: (x) => {
        var $;
        ($ = O.onExited) == null || $.call(O, x), Y();
      }
    }),
    additionalProps: {
      appear: !0,
      in: p
    }
  });
  T === "auto" && !X.muiSupportAuto && (y = void 0);
  const ze = v || (s ? le(te(s)).body : void 0), [Ee, {
    slots: qe,
    slotProps: je,
    ...Ue
  }] = ne("root", {
    ref: r,
    elementType: wt,
    externalForwardedProps: {
      ...L,
      ...k
    },
    shouldForwardComponentProp: !0,
    additionalProps: {
      slots: {
        backdrop: a.backdrop
      },
      slotProps: {
        backdrop: ht(typeof c.backdrop == "function" ? c.backdrop(z) : c.backdrop, {
          invisible: !0
        })
      },
      container: ze,
      open: p
    },
    ownerState: z,
    className: oe(W.root, P)
  }), [He, Ke] = ne("paper", {
    ref: N,
    className: W.paper,
    elementType: ke,
    externalForwardedProps: L,
    shouldForwardComponentProp: !0,
    additionalProps: {
      elevation: S,
      style: re ? void 0 : {
        opacity: 0
      }
    },
    ownerState: z
  });
  return /* @__PURE__ */ M(Ee, {
    ...Ue,
    ...!Pt(Ee) && {
      slots: qe,
      slotProps: je,
      disableScrollLock: D
    },
    children: /* @__PURE__ */ M(X, {
      ...Ye,
      timeout: y,
      children: /* @__PURE__ */ M(He, {
        ...Ke,
        children: E
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Fe.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: ot,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: lt(t.oneOfType([ue, t.func]), (n) => {
    if (n.open && (!n.anchorReference || n.anchorReference === "anchorEl")) {
      const o = te(n.anchorEl);
      if (o && o.nodeType === 1) {
        const r = o.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && r.top === 0 && r.left === 0 && r.right === 0 && r.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${o}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: t.shape({
    horizontal: t.oneOfType([t.oneOf(["center", "left", "right"]), t.number]).isRequired,
    vertical: t.oneOfType([t.oneOf(["bottom", "center", "top"]), t.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: t.shape({
    left: t.number.isRequired,
    top: t.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: t.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: t.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  BackdropProps: t.object,
  /**
   * The content of the component.
   */
  children: t.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: t.object,
  /**
   * @ignore
   */
  className: t.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: t.oneOfType([ue, t.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: t.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: rt,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: t.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: t.func,
  /**
   * If `true`, the component is shown.
   */
  open: t.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: t.shape({
    component: ut
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: t.shape({
    backdrop: t.oneOfType([t.func, t.object]),
    paper: t.oneOfType([t.func, t.object]),
    root: t.oneOfType([t.func, t.object]),
    transition: t.oneOfType([t.func, t.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: t.shape({
    backdrop: t.elementType,
    paper: t.elementType,
    root: t.elementType,
    transition: t.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: t.oneOfType([t.arrayOf(t.oneOfType([t.func, t.object, t.bool])), t.func, t.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: t.shape({
    horizontal: t.oneOfType([t.oneOf(["center", "left", "right"]), t.number]).isRequired,
    vertical: t.oneOfType([t.oneOf(["bottom", "center", "top"]), t.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */
  TransitionComponent: t.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: t.oneOfType([t.oneOf(["auto"]), t.number, t.shape({
    appear: t.number,
    enter: t.number,
    exit: t.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: t.object
});
const St = Fe;
function xt(n) {
  return pe("MuiMenu", n);
}
me("MuiMenu", ["root", "paper", "list"]);
const At = {
  vertical: "top",
  horizontal: "right"
}, Lt = {
  vertical: "top",
  horizontal: "left"
}, It = (n) => {
  const {
    classes: o
  } = n;
  return ye({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, xt, o);
}, $t = G(St, {
  shouldForwardProp: (n) => Ve(n) || n === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (n, o) => o.root
})({}), kt = G(ke, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (n, o) => o.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), Ft = G(Ct, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (n, o) => o.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), De = /* @__PURE__ */ g.forwardRef(function(o, r) {
  const f = he({
    props: o,
    name: "MuiMenu"
  }), {
    autoFocus: u = !0,
    children: s,
    className: i,
    disableAutoFocusItem: l = !1,
    MenuListProps: d = {},
    onClose: E,
    open: P,
    PaperProps: v = {},
    PopoverClasses: S,
    transitionDuration: h = "auto",
    TransitionProps: {
      onEntering: p,
      ...e
    } = {},
    variant: a = "selectedMenu",
    slots: c = {},
    slotProps: A = {},
    ...m
  } = f, T = mt(), b = {
    ...f,
    autoFocus: u,
    disableAutoFocusItem: l,
    MenuListProps: d,
    onEntering: p,
    PaperProps: v,
    transitionDuration: h,
    TransitionProps: e,
    variant: a
  }, D = It(b), k = u && !l && P, N = g.useRef(null), z = (y, L) => {
    N.current && N.current.adjustStyleForScrollbar(y, {
      direction: T ? "rtl" : "ltr"
    }), p && p(y, L);
  }, W = (y) => {
    y.key === "Tab" && (y.preventDefault(), E && E(y, "tabKeyDown"));
  };
  let q = -1;
  g.Children.map(s, (y, L) => {
    /* @__PURE__ */ g.isValidElement(y) && (process.env.NODE_ENV !== "production" && xe.isFragment(y) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), y.props.disabled || (a === "selectedMenu" && y.props.selected || q === -1) && (q = L));
  });
  const U = {
    slots: c,
    slotProps: {
      list: d,
      transition: e,
      paper: v,
      ...A
    }
  }, V = dt({
    elementType: c.root,
    externalSlotProps: A.root,
    ownerState: b,
    className: [D.root, i]
  }), [re, _] = ne("paper", {
    className: D.paper,
    elementType: kt,
    externalForwardedProps: U,
    shouldForwardComponentProp: !0,
    ownerState: b
  }), [I, F] = ne("list", {
    className: oe(D.list, d.className),
    elementType: Ft,
    shouldForwardComponentProp: !0,
    externalForwardedProps: U,
    getSlotProps: (y) => ({
      ...y,
      onKeyDown: (L) => {
        var X;
        W(L), (X = y.onKeyDown) == null || X.call(y, L);
      }
    }),
    ownerState: b
  }), Y = typeof U.slotProps.transition == "function" ? U.slotProps.transition(b) : U.slotProps.transition;
  return /* @__PURE__ */ M($t, {
    onClose: E,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: T ? "right" : "left"
    },
    transformOrigin: T ? At : Lt,
    slots: {
      root: c.root,
      paper: re,
      backdrop: c.backdrop,
      ...c.transition && {
        // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
        transition: c.transition
      }
    },
    slotProps: {
      root: V,
      paper: _,
      backdrop: typeof A.backdrop == "function" ? A.backdrop(b) : A.backdrop,
      transition: {
        ...Y,
        onEntering: (...y) => {
          var L;
          z(...y), (L = Y == null ? void 0 : Y.onEntering) == null || L.call(Y, ...y);
        }
      }
    },
    open: P,
    ref: r,
    transitionDuration: h,
    ownerState: b,
    ...m,
    classes: S,
    children: /* @__PURE__ */ M(I, {
      actions: N,
      autoFocus: u && (q === -1 || l),
      autoFocusItem: k,
      variant: a,
      ...F,
      children: s
    })
  });
});
process.env.NODE_ENV !== "production" && (De.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: t.oneOfType([ue, t.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: t.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: t.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: t.object,
  /**
   * @ignore
   */
  className: t.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: t.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @deprecated use the `slotProps.list` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  MenuListProps: t.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: t.func,
  /**
   * If `true`, the component is shown.
   */
  open: t.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: t.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: t.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: t.shape({
    backdrop: t.oneOfType([t.func, t.object]),
    list: t.oneOfType([t.func, t.object]),
    paper: t.oneOfType([t.func, t.object]),
    root: t.oneOfType([t.func, t.object]),
    transition: t.oneOfType([t.func, t.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: t.shape({
    backdrop: t.elementType,
    list: t.elementType,
    paper: t.elementType,
    root: t.elementType,
    transition: t.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: t.oneOfType([t.arrayOf(t.oneOfType([t.func, t.object, t.bool])), t.func, t.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: t.oneOfType([t.oneOf(["auto"]), t.number, t.shape({
    appear: t.number,
    enter: t.number,
    exit: t.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: t.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: t.oneOf(["menu", "selectedMenu"])
});
const Dt = De, Wt = (n) => {
  const [o, r] = Z.useState(null), [f, u] = Z.useState(""), [s, i] = Z.useState(() => {
    var e;
    if (n.multiple) {
      if (typeof ((e = n.value) == null ? void 0 : e[0]) == "string") {
        const a = n.options.filter((c) => typeof c == "string" ? n.value.includes(c) : n.value.join(",").includes(c.value));
        return a.length ? a : [n.value];
      }
      return n.value;
    }
    return [];
  }), l = !!o, d = (e) => {
    r(e.currentTarget);
  }, E = Z.useMemo(() => {
    const e = f.trim().toLowerCase();
    return typeof n.options[0] == "string" && e.length > 0 ? n.options.filter((a) => a.toLowerCase().includes(e)) : typeof n.options[0] == "object" && e.length > 0 ? n.options.filter((a) => a.label.toLowerCase().includes(e)) : n.options;
  }, [n.options, f]), P = () => {
    r(null), u("");
  }, v = (e) => {
    if (n.multiple) {
      const a = s.some((A) => JSON.stringify(A) === JSON.stringify(e));
      let c = structuredClone(s);
      a ? (c = s.filter((A) => JSON.stringify(A) !== JSON.stringify(e)), i(c)) : (c.push(e), i(c)), n.onChange(c);
      return;
    } else
      n.onChange(e);
    P();
  }, S = Z.useMemo(() => {
    const e = {};
    for (let a = 0; a < E.length; a++) {
      const c = E[a];
      typeof c != "string" && c.group && (e[c.group] ? e[c.group].push(c) : e[c.group] = [c]);
    }
    return e;
  }, [E]), h = Ce(() => {
    if (typeof n.value == "string") {
      if (typeof n.options[0] == "object") {
        const e = n.options.find((a) => a.value === n.value);
        if (e)
          return e.label;
      }
      return n.value;
    }
    return n.value.label;
  }, [n.options, n.value]), p = Ce(() => n.variant === "standard" ? w.value : n.variant === "outlined" ? `${w["value-outlined"]} ${w.value}` : n.variant === "filled" ? `${w["value-filled"]} ${w.value}` : n.variant === "none" ? w["value-none"] : w.value, [n.variant]);
  return /* @__PURE__ */ K(We, { children: [
    /* @__PURE__ */ M("label", { className: w.label, children: n.label }),
    /* @__PURE__ */ K("div", {
      className: p,
      style: n.style,
      onClick: d,
      // check if multiple is enabled and display chips if true else display the value
      children: [
        n.multiple ? /* @__PURE__ */ M("div", { className: w.multiChips, children: s.map((e) => /* @__PURE__ */ K("div", { className: w.chip, onClick: (a) => {
          a.stopPropagation();
        }, children: [
          n.startIcon ? /* @__PURE__ */ M("i", { className: w.icon, children: n.startIcon }) : null,
          typeof e == "string" ? e : e.label
        ] }, typeof e == "string" ? e : e.value)) }) : /* @__PURE__ */ K("span", { className: w.valueText, children: [
          n.startIcon ? /* @__PURE__ */ M("i", { className: w.icon, children: n.startIcon }) : null,
          h
        ] }),
        /* @__PURE__ */ M("svg", { width: 16, focusable: "false", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ M("path", { d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" }) })
      ]
    }),
    /* @__PURE__ */ K(
      Dt,
      {
        open: l,
        anchorEl: o,
        onClose: P,
        className: w.menu,
        children: [
          /* @__PURE__ */ K("div", { className: w.input, children: [
            /* @__PURE__ */ M("input", { type: "text", value: f, onChange: (e) => u(e.target.value) }),
            /* @__PURE__ */ M("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", viewBox: "0 0 24 24", children: /* @__PURE__ */ M("g", { transform: "translate(24 0) scale(-1 1)", children: /* @__PURE__ */ M("path", { d: "m19.6 21l-6.3-6.3q-.75.6-1.725.95T9.5 16q-2.725 0-4.612-1.888T3 9.5q0-2.725 1.888-4.612T9.5 3q2.725 0 4.613 1.888T16 9.5q0 1.1-.35 2.075T14.7 13.3l6.3 6.3zM9.5 14q1.875 0 3.188-1.312T14 9.5q0-1.875-1.312-3.187T9.5 5Q7.625 5 6.313 6.313T5 9.5q0 1.875 1.313 3.188T9.5 14" }) }) })
          ] }),
          /* @__PURE__ */ M("div", { className: w.options, children: Object.keys(S).length ? Object.keys(S).map((e) => /* @__PURE__ */ K("div", { children: [
            /* @__PURE__ */ M("div", { className: w.group, children: e }),
            S[e].map((a) => {
              const c = Array.isArray(n.value) ? s.some((A) => JSON.stringify(A) === JSON.stringify(a)) : JSON.stringify(a) === JSON.stringify(n.value);
              return n.renderOption ? n.renderOption(a, c) : /* @__PURE__ */ K(
                "div",
                {
                  className: `${w.option} ${c ? w.selected : ""} `,
                  style: { textTransform: "capitalize" },
                  onClick: () => v(a),
                  children: [
                    n.multiple && /* @__PURE__ */ M("input", { type: "checkbox", checked: c }),
                    n.startIcon ? /* @__PURE__ */ M("i", { className: w.icon, children: n.startIcon }) : null,
                    typeof a == "string" ? a : a.label
                  ]
                },
                typeof a == "string" ? a : a.value
              );
            })
          ] }, e)) : E.map((e) => {
            const a = Array.isArray(n.value) ? s.some((c) => JSON.stringify(c) === JSON.stringify(e)) : JSON.stringify(e) === JSON.stringify(n.value);
            return n.renderOption ? n.renderOption(e, a) : /* @__PURE__ */ K(
              "div",
              {
                className: `${w.option} ${a ? w.selected : ""}`,
                style: { textTransform: "capitalize" },
                onClick: () => v(e),
                children: [
                  n.multiple && /* @__PURE__ */ M("input", { type: "checkbox", checked: a }),
                  n.startIcon ? /* @__PURE__ */ M("i", { className: w.icon, children: n.startIcon }) : null,
                  typeof e == "string" ? e : e.label
                ]
              },
              typeof e == "string" ? e : e.value
            );
          }) })
        ]
      }
    )
  ] });
};
export {
  Wt as default
};
